import { Duration, ZonedDateTime } from "@js-joda/core";
import {
  FieldName,
  FieldType,
  FieldValueFormat,
  dateFieldValueFormat,
  integerFieldValueFormat,
  listFieldFormat,
  methodFieldValueFormat,
  singleFieldFormat,
  stringFieldValueFormat,
} from "./fields";

/**
 * Allow
 * @see {@link https://www.rfc-editor.org/rfc/rfc9110#section-10.2.1 RFC 9110 10.2.1 Allow}
 */
export const AllowField = new FieldType(
  new FieldName("Allow"),
  listFieldFormat(methodFieldValueFormat),
);

/**
 * Expect
 * @see {@link https://www.rfc-editor.org/rfc/rfc9110#section-10.1.1 RFC 9110 10.1.1 Expect}
 */
export const ExpectField = new FieldType(
  new FieldName("Expect"),
  listFieldFormat(stringFieldValueFormat),
);

/**
 * From
 * @see {@link https://www.rfc-editor.org/rfc/rfc9110#section-10.1.2 RFC 9110 10.1.2 From}
 * @todo use {@link https://www.npmjs.com/package/email-addresses email-addresses}
 */
export const FromField = new FieldType(
  new FieldName("From"),
  singleFieldFormat(stringFieldValueFormat),
);

/**
 * Location
 * @see {@link https://www.rfc-editor.org/rfc/rfc9110#section-10.2.2 RFC 9110 10.2.2 Location}
 */
export const LocationField = new FieldType(
  new FieldName("Location"),
  singleFieldFormat(stringFieldValueFormat),
);

/**
 * Referer
 * @see {@link https://www.rfc-editor.org/rfc/rfc9110#section-10.1.3 RFC 9110 10.1.3 Referer}
 */
export const RefererField = new FieldType(
  new FieldName("Referer"),
  singleFieldFormat(stringFieldValueFormat),
);

const DelayFieldValueFormat: FieldValueFormat<ZonedDateTime | Duration> = {
  read(fieldValue: string) {
    return isNaN(+fieldValue)
      ? dateFieldValueFormat.read(fieldValue)
      : Duration.ofSeconds(integerFieldValueFormat.read(fieldValue));
  },
  write(value: ZonedDateTime | Duration) {
    return value instanceof ZonedDateTime
      ? dateFieldValueFormat.write(value)
      : integerFieldValueFormat.write(value.seconds());
  },
};

/**
 * Retry-After
 * @see {@link https://www.rfc-editor.org/rfc/rfc9110#section-10.2.3 RFC 9110 10.2.3 Retry-After}
 */
export const RetryAfterField = new FieldType(
  new FieldName("Retry-After"),
  singleFieldFormat(DelayFieldValueFormat),
);

/**
 * Server
 * @see {@link https://www.rfc-editor.org/rfc/rfc9110#section-10.2.4 RFC 9110 10.2.4 Server}
 */
export const ServerField = new FieldType(
  new FieldName("Server"),
  singleFieldFormat(stringFieldValueFormat),
);

/**
 * TE
 * @see {@link https://www.rfc-editor.org/rfc/rfc9110#section-10.1.4 RFC 9110 10.1.4 TE}
 */
export const TeField = new FieldType(
  new FieldName("TE"),
  listFieldFormat(stringFieldValueFormat),
);

/**
 * User-Agent
 * @see {@link https://www.rfc-editor.org/rfc/rfc9110#section-10.1.5 RFC 9110 10.1.5 User-Agent}
 */
export const UserAgentField = new FieldType(
  new FieldName("User-Agent"),
  singleFieldFormat(stringFieldValueFormat),
);
